<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="code-popup" >
    <div style="max-height:500px;overflow-y: scroll;">
        <p class="intitle">网页客服代码接入</p>
        <p style="height: 36px;">将次此代码嵌入到你的网站页面<pre style="display:inline-block"> &lt;/body&gt;</pre>标签之前,即可启用在线客服<p>
        <p style="color: red">温馨提示: 请确保访客不在IP黑名单中<p>
         <div class="inback">
        <pre>
&lt;script&gt;
  (function(win, doc, src, opt) {
    win[opt] = win[opt] || function () {
    win[opt].options = arguments[0]};
    var script = doc.createElement("script");
    script.async = 1;
    script.src = src;
    doc.body.appendChild(script);
  })
  (window,document,"<span>{{baseImgURL}}</span>/mpcc/static/webchat.js?v="+Date.now(), "options");
    options({
      token: "<span>{{inToken}}</span>",
      companyCode:"<span>{{companyCode}}</span>",
    });
&lt;/script&gt;
        </pre>
        </div>
        <p class="intitle">H5链接</p>
        <div class="inback">
          {{baseImgURL}}/mpcc/externalPage?token={{inToken}}&language=zh_CN&companyCode={{companyCode}}
        </div>
        <a @click="generateQrcode" class="generate" style="color:#409EFF;border-bottom:1px solid #409EFF">生成二维码</a>
        <div class="qrcode" style="display:none">
          <p class="intitle">二维码</p>
          <div >
            <img width="150px" height="150px" :src="qrcodeLink"/>
          </div>
        </div>
    </div>
  </Modal>
</template>

<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'

export default {
  name: 'CodeInsertPop',
  mixins: [publicFunClass],
  props: {
    showCodeInsert: Boolean,
    searchId:String,
    inToken:String,
  },
  data() {
    return {
      model: false,
      title: '代码接入',
      companyCode: localStorage.getItem("companyId"),
      qrcodeLink:'',
    }
  },
  methods: {
    cancel: function () {
      this.$emit('closeCodeInsert', false);
      $(".qrcode").hide();
      $(".generate").show();
    },

    initSearch: function () {

    },
    generateQrcode:function () {
        let that = this;
        let codeurl=this.baseImgURL+'/mpcc/externalPage?token='+this.inToken+'&language=zh_CN&companyCode='+this.companyCode;
        const Base64 = require('js-base64').Base64;
        codeurl = Base64.encode(codeurl);
        this.$http.get("common/generateQRCode.json?content="+codeurl).then(function (res) {
          let result=res.data;
          that.createCode(result);

        })
    },
    createCode:function (result) {
       this.qrcodeLink=result;
      $(".qrcode").show();
      $(".generate").hide();
    },

  },
  watch: {
    showCodeInsert: function () {
      this.model = this.showCodeInsert
      if (this.showCodeInsert) {
        this.initSearch()
      }
    }
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/CodeInsertPop.vue